import React, { useState } from "react";
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const loginWrapper = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
}
const form = {
    display: 'flex',
    flexDirection: 'column'
}

async function loginUser(credentials) {
    return fetch('/api/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(credentials)
    }).then(data => data.json())
}

export const Login = ({setToken}) => {
    const [username, setUsername] = useState();
    const [password, setPassword] = useState();
    const { t } = useTranslation();

    const handleSubmit = async e => {
        e.preventDefault();
        const token = await loginUser({
          username,
          password
        });
        setToken(token);
    }

    return(
        <div style={loginWrapper}>
            <h1>{t("login_text")}</h1>
            <form style={form} onSubmit={handleSubmit}>
                <label>
                    <p>{t("login_username")}</p>
                    <input type="text" onChange={e => setUsername(e.target.value)} />
                </label>
                <label>
                    <p>{t("login_password")}</p>
                    <input type="password" onChange={e => setPassword(e.target.value)} />
                </label>
                <div>
                    <button type="submit">{t("create_signtask_nav_login")}</button>
                </div>
            </form>
        </div>
    );
}

Login.propTypes = {
    setToken: PropTypes.func.isRequired
}